import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import PartnerPlanForm from 'containers/PartnerPlanForm'
import PartnerPlanNoteForm from 'containers/PartnerPlanNoteForm'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { getPartnerPlan, getPartnerPlanDocuments, deletePartnerPlanDocument } from 'actions/partnerPlan'
import { editPartnerPlan } from 'actions/partnerPlanForm'
import { modalShow, modalHide } from 'actions/modals'
import BackTo from 'components/BackTo'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import Dialog from 'components/Dialog'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import constants from 'constants'
import { headerTitleName } from 'utils/headerTitleName'
import { getEmployeeId } from 'utils/getEmployeeId'

class PartnerPlan extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    deletePartnerPlanDocument: PropTypes.func.isRequired,
    editPartnerPlan: PropTypes.func.isRequired,
    getPartnerPlan: PropTypes.func.isRequired,
    getPartnerPlanDocuments: PropTypes.func.isRequired,
    modalHide: PropTypes.func.isRequired,
    modalShow: PropTypes.func.isRequired,
    partnerPlan: PropTypes.instanceOf(Array),
    partnerPlanForm: PropTypes.object.isRequired,
    routes: PropTypes.instanceOf(Array),
    // eslint-disable-next-line react/no-unused-prop-types
    selectedPartner: PropTypes.object,
    selectedPlan: PropTypes.object,
    setErrorMessage: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    partnerPlan: {},
    selectedPartner: null,
    selectedPlan: null,
    currentUser: null,
  }

  constructor(props) {
    super(props)
    this.state = {
      formId: '',
      noteHeader: '',
      deleteDocumentDialog: false,
      documentToDelete: '',
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.props.getPartnerPlan(
        this.props.currentUser.EmployeeId,
        this.props.selectedPlan.EmployeeId,
        this.props.selectedPlan.PlanYear,
      )
      this.props.getPartnerPlanDocuments(
        this.props.selectedPlan.EmployeeId,
        this.props.selectedPlan.PlanYear,
        this.props.selectedPlan.PlanStatus,
        this.props.selectedPlan.Role,
      )
    }, 100)
  }

  handleOpenPartnerPlanForm = (id) => {
    this.setState({ formId: id }, () => { this.props.modalShow(id) })
    // setTimeout(() => { this.setState({ this.props.modalShow(id) }) }, 500)
  }

  handleOpenPartnerPlanNoteForm = (noteHeader) => {
    this.noteHeader = noteHeader
    this.setState({ noteHeader }, () => { this.props.modalShow(constants.PARTNERPLAN.FORMS.NOTES) })
    // setTimeout(() => { this.props.modalShow(constants.PARTNERPLAN.FORMS.NOTES) }, 500)
  }

  handleOpenDialog = (id) => {
    setTimeout(() => { this.setState({ documentToDelete: id }) }, 500)
    this.setState({ deleteDocumentDialog: true })
  }

  handleCloseDialog = () => {
    this.setState({ deleteDocumentDialog: false })
  }

  handleSubmitDialog = () => {
    this.props.deletePartnerPlanDocument(
      this.state.documentToDelete,
      this.props.selectedPlan.EmployeeId,
      this.props.selectedPlan.PlanYear,
      this.props.selectedPlan.PlanStatus,
      this.props.selectedPlan.Role,
    )
    this.setState({ deleteDocumentDialog: false })
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: headerTitleName(this.props.currentUser, 'Partner plan'),
      history,
      location,
      path,
      match,
      routes,
    }
  }

  render() {
    const {
      // eslint-disable-next-line no-shadow
      routes, currentUser, partnerPlan, partnerPlanForm, selectedPartner, selectedPlan, editPartnerPlan,
    } = this.props

    const deleteDocumentDialogProps = {
      actions: [
        { label: 'CANCEL', onClick: this.handleCloseDialog },
        { label: 'DELETE', onClick: this.handleSubmitDialog },
      ],
      title: 'Delete Partner plan document',
      active: this.state.deleteDocumentDialog,
      onClose: this.handleCloseDialog,
    }

    return (
      <MainLayout
        bannerNavProps={{ ...this.bannerProps() }}
        handleOpenDialog={this.handleOpenDialog}
        partnerPlanDocuments={this.props.partnerPlan.partnerPlanDocuments}// {this.props.partnerPlan.Documents}
        sidebarType="partnerPlan"
      >
        <BackTo displayText={`${this.props.selectedPlan.Name} ${this.props.selectedPlan.PlanYear}: Partner plan`} history={this.props.history} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              currentUser={currentUser}
              editPartnerPlan={editPartnerPlan}
              openPartnerPlanForm={this.handleOpenPartnerPlanForm}
              openPartnerPlanNoteForm={this.handleOpenPartnerPlanNoteForm}
              partnerPlan={partnerPlan}
              partnerPlanForm={partnerPlanForm}
              selectedPartner={selectedPartner}
              selectedPlan={selectedPlan}
            />
            ))}
          <PartnerPlanForm currentUser={currentUser} hide={this.props.modalHide} id={this.state.formId} />
          <PartnerPlanNoteForm currentUser={currentUser} hide={this.props.modalHide} noteHeader={this.state.noteHeader} />
          <Dialog {...deleteDocumentDialogProps}>Are you sure you want to delete this Partner plan document?</Dialog>
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  partnerPlan: state.partnerPlan,
  partnerPlanForm: state.partnerPlanForm,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
  selectedPlan: (Object.keys(state.partnerPlans.selectedPlan).length === 0 && sessionStorage.getItem('SelectedPlan') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPlan')) :
    state.partnerPlans.selectedPlan),
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getPartnerPlan,
  getPartnerPlanDocuments,
  deletePartnerPlanDocument,
  editPartnerPlan,
  modalShow,
  modalHide,
})(PartnerPlan))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlan.js